/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import get from 'transmute/get';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { Popover } from 'foundations-components/transitional/components/Popover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import PhoneFromNumberOptionsWorkspace from './PhoneFromNumberOptionsWorkspace';
import { RightIcon } from 'foundations-assets';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { memo, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallSettingWrapper = styled.div.withConfig({
  displayName: "CurrentSettingsInfoWorkspace__CallSettingWrapper",
  componentId: "sc-1fsv2n7-0"
})(["cursor:pointer;font-weight:500;background-color:transparent;&.is--disabled{opacity:0.5;}padding:", ";&:hover{background-color:", ";}"], ({
  theme
}) => `${theme.space['300']} ${theme.space['400']}`, ({
  theme
}) => `${theme.color['fill-secondary-subtle']}`);
function CurrentSettingsInfoWorkspace({
  appIdentifier,
  selectedCallProvider,
  selectedFromNumber,
  handleSelectFromNumber,
  channelAssignedPhoneNumbers,
  showFromNumberDropdown
}) {
  const [showPhoneFromNumberOptions, setShowPhoneFromNumberOptions] = useState(false);
  const providerName = useMemo(() => get('name', selectedCallProvider), [selectedCallProvider]);
  let numberOrProvider = providerName;
  if (selectedFromNumber) {
    if (selectedFromNumber.get('nickname') && selectedFromNumber.get('nickname').length) {
      numberOrProvider = `${selectedFromNumber.get('nickname')} ${selectedFromNumber.get('friendlyName')}`;
    } else if (selectedFromNumber.get('friendlyName')) {
      numberOrProvider = selectedFromNumber.get('friendlyName');
    }
  }
  return /*#__PURE__*/_jsx(Popover, {
    open: showPhoneFromNumberOptions,
    onOpenChange: () => setShowPhoneFromNumberOptions(false),
    animateOnToggle: true,
    inlineSize: "300px",
    content: {
      body: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "-500",
        marginInline: "-600",
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(PhoneFromNumberOptionsWorkspace, {
          appIdentifier: appIdentifier,
          channelAssignedPhoneNumbers: channelAssignedPhoneNumbers,
          selectedFromNumber: selectedFromNumber,
          onSelect: handleSelectFromNumber
        })
      })
    },
    placement: "right bottom",
    arrowSize: "none",
    children: showFromNumberDropdown &&
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(CallSettingWrapper, {
      onClick: () => setShowPhoneFromNumberOptions(!showPhoneFromNumberOptions),
      "data-selenium-test": "open-pre-call-popup-from-numbers",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "callSettingsWidget.callFrom",
          options: {
            numberOrProvider
          }
        }), /*#__PURE__*/_jsx(RightIcon, {
          size: "300"
        })]
      })
    })
  });
}
CurrentSettingsInfoWorkspace.propTypes = {
  appIdentifier: PropTypes.string,
  selectedCallProvider: RecordPropType('CallingProvider'),
  selectedFromNumber: RecordPropType('FromNumberRecord'),
  handleSelectFromNumber: PropTypes.func,
  channelAssignedPhoneNumbers: ImmutablePropTypes.listOf('FromNumberRecord')
};
export default /*#__PURE__*/memo(CurrentSettingsInfoWorkspace);